import{l as c}from"./ninox-components-GQTCIGTF.js";import{m as i}from"./ninox-components-2ADN25D5.js";import{f as e}from"./ninox-components-DFJEWGV6.js";import{f as n}from"./ninox-components-MYF6AQNE.js";import{k as r}from"./ninox-components-R4FVH3NU.js";import{a as l}from"./ninox-components-I2GBTDK4.js";import{c as t}from"./ninox-components-YAP3BY3K.js";import a from"styled-components";var b=a.div`
    display: inline-flex;
    align-items: center;
    width: fit-content;
    flex-shrink: 0;
    position: relative;
    border-radius: ${e.medium};
`,m=a.select`
    box-sizing: border-box;
    width: auto;
    min-width: 100%;
    height: calc(${c.m} + 2 * ${n.tiny});

    appearance: none;
    cursor: pointer;

    font-family: ${t.sans};
    font-size: ${r.medium};
    font-weight: ${l.normal};

    ${({theme:o})=>o.combobox.default}
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);

    outline: none;
    border-radius: inherit;
    border-width: ${n.tiny};
    border-style: solid;

    transition-timing-function: ease;
    transition-duration: 150ms;
    transition-property: color, background-color, border-color;

    &:focus {
        outline: none;
        ${({theme:o})=>o.combobox.focus}
    }

    &:hover {
        ${({theme:o})=>o.combobox.hover}
    }

    &:invalid {
        ${({theme:o})=>o.combobox.invalid}
    }

    &:disabled {
        cursor: default;
        ${({theme:o})=>o.combobox.disabled}
    }

    & option {
        font-family: ${t.sans};
        font-weight: ${l.normal};
        font-size: ${r.medium};

        background-color: inherit;
        color: inherit;
        border-radius: ${e.small};

        padding: ${i.xxx_small} ${i.x_small};
        outline: none;
        border: none;
    }

    & option[value=''],
    & option:not([value]) {
        ${({theme:o})=>o.combobox.placeholder}
    }

    & option:focus-visible:not(:hover) {
        ${({theme:o})=>o.combobox.option.single.focus};
    }

    & option:hover {
        ${({theme:o})=>o.combobox.option.single.hover};
    }

    & option:active,
    & option:checked {
        ${({theme:o})=>o.combobox.option.single.active};
    }

    &:disabled {
        option {
            ${({theme:o})=>o.combobox.disabled}
        }
        option:active,
        option:checked {
            color: ${({theme:o})=>o.combobox.option.single.active.color};
        }
    }

    &[multiple] {
        height: auto;
        padding: ${i.x_small};
    }

    :-moz-focusring {
        color: transparent;
        text-shadow: 0 0 0 ${({theme:o})=>o.combobox.default.color};
    }
`,p=a.div`
    position: absolute;
    pointer-events: none;
    color: ${({theme:o})=>o.combobox.icon.default};
`;export{b as a,m as b,p as c};
//# sourceMappingURL=ninox-components-WEIEHEBK.js.map